<div class="header_container">
  <div class="topbar">
    <!-- Off-canvas nav toggle: only rendered by CSS below 992px, where the
         sidebar slides out. Without it the menu is unreachable on a touch
         tablet, which has no :hover. -->
    <button
      type="button"
      class="sidebar_toggle"
      title="Menu"
      aria-label="Toggle navigation"
      [attr.aria-expanded]="sidebarOpen"
      (click)="toggleSidebar($event)"
    >
      <i class="fa" [ngClass]="sidebarOpen ? 'fa-times' : 'fa-bars'"></i>
    </button>

    <div class="logo">
      <a>
        <!-- <img src="assets/images/IM-main-logo3.png" /> -->
        <img src="assets/images/logo.png" />
        <!-- <img style="width: 50%" src="assets/images/new_logo.svg" /> -->
        <!-- image -->
      </a>
      <div class="portal-divider"></div>
      <div class="portal-identity" [ngSwitch]="userType">
        <div *ngSwitchCase="'laundry'" class="portal-info portal-laundry">
          <i class="fa fa-shirt portal-icon"></i>
          <div class="portal-text">
            <span class="portal-label">PORTAL</span>
            <span class="portal-name">Laundry</span>
          </div>
        </div>
        <div *ngSwitchCase="'restaurant'" class="portal-info portal-restaurant">
          <i class="fa fa-cutlery portal-icon"></i>
          <div class="portal-text">
            <span class="portal-label">PORTAL</span>
            <span class="portal-name">Restaurant</span>
          </div>
        </div>
        <div *ngSwitchCase="'apartment'" class="portal-info portal-apartment">
          <i class="fa fa-building portal-icon"></i>
          <div class="portal-text">
            <span class="portal-label">PORTAL</span>
            <span class="portal-name">{{
              apartmentType === "residential"
                ? "Residential Apartments"
                : "Service Request"
            }}</span>
          </div>
        </div>
        <div *ngSwitchCase="'club'" class="portal-info portal-club">
          <i class="fa fa-users portal-icon"></i>
          <div class="portal-text">
            <span class="portal-label">PORTAL</span>
            <span class="portal-name">Club</span>
          </div>
        </div>
        <div *ngSwitchCase="'spa'" class="portal-info portal-club">
          <i class="fa fa-spa portal-icon"></i>
          <div class="portal-text">
            <span class="portal-label">PORTAL</span>
            <span class="portal-name">Spa</span>
          </div>
        </div>
      </div>
    </div>

    <div class="topbar_right">
      <!-- User status based on userType -->
      <div [ngSwitch]="userType">
        <div *ngSwitchCase="'apartment'" class="status-wrapper">
          <span
            class="status-text"
            [ngClass]="activestatus == 1 ? 'active' : 'inactive'"
          >
            {{ activestatus == 1 ? "Active" : "Inactive" }}
          </span>

          <label class="switch">
            <input
              type="checkbox"
              [checked]="activestatus == 1"
              (change)="statuschange($event, userType)"
            />
            <span class="slider"></span>
          </label>
        </div>

        <div *ngSwitchCase="'laundry'" class="status-wrapper">
          <span
            class="status-text"
            [ngClass]="activestatus == 1 ? 'active' : 'inactive'"
          >
            {{ activestatus == 1 ? "Active" : "Inactive" }}
          </span>
          <label class="switch">
            <input
              type="checkbox"
              [checked]="activestatus == 1"
              (change)="statuschange($event, userType)"
            />
            <span class="slider"></span>
          </label>
        </div>

        <div *ngSwitchCase="'restaurant'" class="status-wrapper">
          <span
            class="status-text"
            [ngClass]="activestatus == 1 ? 'active' : 'inactive'"
          >
            {{ activestatus == 1 ? "Active" : "Inactive" }}
          </span>
          <label class="switch">
            <input
              type="checkbox"
              class="checkbox"
              [checked]="activestatus == 1"
              (change)="statuschange($event, userType)"
            />
            <span class="slider"></span>
          </label>
        </div>
        <div *ngSwitchCase="'club'" class="status-wrapper">
          <span
            class="status-text"
            [ngClass]="activestatus == 1 ? 'active' : 'inactive'"
          >
            {{ activestatus == 1 ? "Active" : "Inactive" }}
          </span>
          <label class="switch">
            <input
              type="checkbox"
              class="checkbox"
              [checked]="activestatus == 1"
              (change)="statuschange($event, userType)"
            />
            <span class="slider"></span>
          </label>
        </div>
        <div *ngSwitchCase="'spa'" class="status-wrapper">
          <span
            class="status-text"
            [ngClass]="activestatus == 1 ? 'active' : 'inactive'"
          >
            {{ activestatus == 1 ? "Active" : "Inactive" }}
          </span>
          <label class="switch">
            <input
              type="checkbox"
              class="checkbox"
              [checked]="activestatus == 1"
              (change)="statuschange($event, userType)"
            />
            <span class="slider"></span>
          </label>
        </div>
      </div>

      <!-- <button
        *ngIf="hasPermission('emergency') || (userType == 'apartment' && !isStaff)"
        title="Emergency Notification"
        type="button"
        [routerLink]="['/emergency-notification']"
        class="emergency-btn"
      >
        <i class="fa fa-exclamation-triangle"></i>
      </button> -->

      <!-- Resident SOS docked here after the full-screen siren; opens SOS History -->
      <button
        #sosDock
        *ngIf="canSeeSos && (sosAlert.activeCount > 0 || (sosAlert.expanded$ | async))"
        type="button"
        class="sos_dock"
        [class.sos_dock_waiting]="(sosAlert.expanded$ | async) || sosFlying"
        title="Pending SOS — open SOS History"
        (click)="openSosHistory()"
      >
        <span class="sos_siren sos_siren_sm"><ng-container *ngTemplateOutlet="sirenTpl; context: { $implicit: 'sm' }"></ng-container></span>
        <span class="sos_dock_count" *ngIf="sosAlert.activeCount > 0">{{ sosAlert.activeCount }}</span>
      </button>

      <button
        *ngIf="hasOwnerSession()"
        title="Back to Collective Dashboard"
        type="button"
        (click)="backToCollectiveDashboard()"
        class="owner_back_btn"
      >
        <i class="fa fa-th-large me-1"></i> Collective Dashboard
      </button>

      <span class="topbar_divider"></span>

      <div class="topbar_profile">
        <button type="button" class="avatar_btn" title="Logout" (click)="logout()">
          <img src="assets/images/user.png" alt="" />
        </button>

        <div class="topbar_name">
          <span class="topbar_greeting">Hi, {{ username }}</span>
          <span class="rest_main_name"
            >Name : <span class="rest_number">{{ apartmentName }}</span></span
          >
          <span class="rest_main_name"
            >Code : <span class="rest_number">{{ code }}</span></span
          >
        </div>
      </div>
    </div>
  </div>
  <!-- Dimmer behind the off-canvas sidebar (small screens only) -->
  <div
    class="sidebar_backdrop"
    *ngIf="sidebarOpen"
    (click)="closeSidebar()"
  ></div>

  <ul class="menuH_container" [class.menu_open]="sidebarOpen">
    <li class="menu_section">Overview</li>
    <li *ngIf="hasPermission('dashboard') || userType === 'apartment' && !isStaff">
      <a
        [routerLink]="['/dashboard']"
        class="menu-item"
        [ngClass]="{ active: router.url == '/dashboard' }"
        ><b>
          <span class="menu_black"><i class="fa-solid fa-gauge"></i></span>
          <span class="menu_white"><i class="fa-solid fa-gauge"></i></span
        ></b>
        <span>Dashboard</span>
      </a>
    </li>
    <li
      *ngIf="
        hasPermission('apartment-properties') ||
        hasPermission('apartment-settings') ||
        (userType === 'apartment' && !isStaff && apartmentType === 'residential')
      "
      class="notification-dropdown"
    >
      <a
        href="javascript:void(0)"
        (click)="toggleDropdown('showPropertiesDropdown', $event)"
        class="menu-item"
        [ngClass]="{ active: propertyUrl() }"
      >
        <b>
          <span class="menu_black"><i class="fa-solid fa-house"></i></span>
          <span class="menu_white"><i class="fa-solid fa-house"></i></span>
        </b>
        <span class="notify-text">
          Properties
          <i
            class="fa-solid fa-chevron-down notify-arrow"
            [class.rotate]="showPropertiesDropdown"
          ></i>
        </span>
      </a>
      <ul class="notify-menu" *ngIf="showPropertiesDropdown">
        <li
          *ngIf="
            hasPermission('apartment-properties') ||
            (userType === 'apartment' && !isStaff)
          "
        >
          <a
            [routerLink]="['/apartment-properties']"
            [ngClass]="{
              active: router.url.startsWith('/apartment-properties'),
            }"
          >
            <b>
              <span class="menu_black"
                ><i class="fa-solid fa-building"></i
              ></span>
              <span class="menu_white"
                ><i class="fa-solid fa-building"></i
              ></span>
            </b>
            <span>Units</span>
          </a>
        </li>
        <li
          *ngIf="
            hasPermission('apartment-settings') ||
            (userType === 'apartment' && !isStaff)
          "
        >
          <a
            [routerLink]="['/apartment-settings']"
            [ngClass]="{ active: router.url.startsWith('/apartment-settings') }"
          >
            <b>
              <span class="menu_black"
                ><i class="fa-solid fa-tower-observation"></i
              ></span>
              <span class="menu_white"
                ><i class="fa-solid fa-tower-observation"></i
              ></span>
            </b>
            <span>Residential Settings</span>
          </a>
        </li>
      </ul>
    </li>
    <li *ngIf="hasPermission('customer') || userType === 'apartment' && !isStaff">
      <a
        [routerLink]="['/customer']"
        class="menu-item"
        [ngClass]="{ active: customerUrl() }"
        ><b>
          <span class="menu_black"><i class="fa-solid fa-users"></i></span>
          <span class="menu_white"><i class="fa-solid fa-users"></i></span
        ></b>
        <span>{{
          apartmentType === "residential" ? "Residents" : "Guest"
        }}</span>
      </a>
    </li>
    <li
      *ngIf="
        (hasPermission('room-service') || userType === 'apartment' && !isStaff) &&
        apartmentType !== 'residential'
      "
    >
      <a
        [routerLink]="['/room-service']"
        class="menu-item"
        [ngClass]="{ active: RoomUrl() }"
        ><b>
          <span class="menu_black"
            ><i class="fa-solid fa-bell-concierge"></i
          ></span>
          <span class="menu_white"
            ><i class="fa-solid fa-bell-concierge"></i></span></b
        ><span>Service Request</span>
      </a>
    </li>
    <li *ngIf="(userType === 'apartment' && !isStaff && apartmentType === 'residential') || hasPermission('residential-service')">
      <a
        [routerLink]="['/residential-service']"
        class="menu-item"
        [ngClass]="{ active: router.url.startsWith('/residential-service') || (router.url.includes('/no-access') && router.url.includes('Residential%20Service')) }"
        ><b>
          <span class="menu_black"
            ><i class="fa-solid fa-bell-concierge"></i
          ></span>
          <span class="menu_white"
            ><i class="fa-solid fa-bell-concierge"></i></span></b
        ><span>Residential Service</span>
      </a>
    </li>
    <li *ngIf="(userType === 'apartment' && !isStaff && apartmentType === 'residential') || hasPermission('facilities')">
      <a
        [routerLink]="['/facilities']"
        class="menu-item"
        [ngClass]="{ active: router.url.startsWith('/facilities') }"
        ><b>
          <span class="menu_black"><i class="fa-solid fa-person-swimming"></i></span>
          <span class="menu_white"><i class="fa-solid fa-person-swimming"></i></span
        ></b>
        <span>Facilities</span>
      </a>
    </li>
    <li *ngIf="(userType === 'apartment' && !isStaff && apartmentType === 'residential') || hasPermission('resident-new-order')">
      <a
        [ngClass]="{ active: ResidentOrderActiveurl() }"
        class="menu-item"
        [routerLink]="['/resident-new-order']"
        ><b>
          <span class="menu_black"
            ><i class="fa-solid fa-cart-shopping"></i
          ></span>
          <span class="menu_white"
            ><i class="fa-solid fa-cart-shopping"></i
          ></span>
        </b>
        <span>Order</span>
      </a>
      <span class="notif_msg" *ngIf="getNewResidentialOrdersCount?.['0'] >= 1">
        {{ getNewResidentialOrdersCount?.["0"] }}
      </span>
    </li>
    <li
      *ngIf="
        hasPermission('room-new-order') ||
        (userType === 'apartment' && !isStaff && apartmentType !== 'residential')
      "
    >
      <a
        [ngClass]="{ active: RoomOrderActiveurl() }"
        class="menu-item"
        [routerLink]="['/room-new-order']"
        ><b>
          <span class="menu_black"
            ><i class="fa-solid fa-cart-shopping"></i
          ></span>
          <span class="menu_white"
            ><i class="fa-solid fa-cart-shopping"></i
          ></span>
        </b>
        <span>Order</span>
      </a>
      <span class="notif_msg" *ngIf="getNewRoomOrdersCount?.['0'] >= 1">
        {{ getNewRoomOrdersCount?.["0"] }}
      </span>
    </li>
    <li
      *ngIf="
        hasPermission('additional-new-order') ||
        (userType === 'apartment' && !isStaff && apartmentType !== 'residential')
      "
    >
      <a
        [ngClass]="{ active: AdditionalOrderActiveurl() }"
        class="menu-item"
        [routerLink]="['/additional-new-order']"
        ><b>
          <span class="menu_black"><i class="fa-solid fa-cart-plus"></i></span>
          <span class="menu_white"><i class="fa-solid fa-cart-plus"></i></span>
        </b>
        <span>Additional Orders</span>
      </a>
      <span class="notif_msg" *ngIf="getAdditionalOrdersCount?.['0'] >= 1">
        {{ getAdditionalOrdersCount?.["0"] }}
      </span>
    </li>
    <li
      class="menu_section"
      *ngIf="
        hasPermission('apartment-staff') ||
        hasPermission('apartment-notification') ||
        hasPermission('audit-logs') ||
        hasPermission('reports-apartment') ||
        hasPermission('reports-residential') ||
        (userType === 'apartment' && !isStaff)
      "
    >
      Admin
    </li>
    <li *ngIf="hasPermission('apartment-staff') || userType === 'apartment' && !isStaff">
      <a
        [routerLink]="['/apartment-staff']"
        class="menu-item"
        [ngClass]="{ active: ApartmentStaffUrl() }"
        ><b>
          <span class="menu_black"><i class="fa-solid fa-id-badge"></i></span>
          <span class="menu_white"
            ><i class="fa-solid fa-id-badge"></i></span></b
        ><span>Staff</span>
      </a>
    </li>
    <li
      *ngIf="userType === 'apartment' && !isStaff || hasPermission('apartment-notification') || hasPermission('audit-logs') || hasPermission('reports-residential') || hasPermission('reports-apartment')"
      class="notification-dropdown"
    >
      <a
        href="javascript:void(0)"
        (click)="toggleDropdown('showApartmentSettingsDropdown', $event)"
        [ngClass]="{ active: apartmentSettingsUrl() }"
        class="menu-item"
      >
        <b>
          <span class="menu_black"
            ><i class="fa fa-cog" aria-hidden="true"></i
          ></span>
          <span class="menu_white"
            ><i class="fa fa-cog" aria-hidden="true"></i
          ></span>
        </b>
        <span class="notify-text">
          Settings
          <i
            class="fa-solid fa-chevron-down notify-arrow"
            [class.rotate]="showApartmentSettingsDropdown"
          ></i>
        </span>
      </a>
      <ul class="notify-menu" *ngIf="showApartmentSettingsDropdown">
        <li
          *ngIf="
            (hasPermission('reports-apartment') || userType === 'apartment' && !isStaff) &&
            apartmentType !== 'residential'
          "
        >
          <a
            [routerLink]="['/reports-apartment']"
            [ngClass]="{ active: router.url == '/reports-apartment' }"
          >
            <b>
              <span class="menu_black"
                ><i class="fa fa-file-text" aria-hidden="true"></i
              ></span>
              <span class="menu_white"
                ><i class="fa fa-file-text" aria-hidden="true"></i
              ></span>
            </b>
            <span>Report</span>
          </a>
        </li>
        <li *ngIf="(userType === 'apartment' && !isStaff && apartmentType === 'residential') || hasPermission('reports-residential')">
          <a
            [routerLink]="['/reports-residential']"
            [ngClass]="{ active: router.url == '/reports-residential' }"
          >
            <b>
              <span class="menu_black"
                ><i class="fa fa-file-text" aria-hidden="true"></i
              ></span>
              <span class="menu_white"
                ><i class="fa fa-file-text" aria-hidden="true"></i
              ></span>
            </b>
            <span>Report</span>
          </a>
        </li>
        <li
          *ngIf="
            hasPermission('apartment-notification') || userType === 'apartment' && !isStaff
          "
        >
          <a
            [routerLink]="['/apartment-notification']"
            [ngClass]="{ active: router.url == '/apartment-notification' }"
          >
            <b>
              <span class="menu_black"><i class="fa-solid fa-bell"></i></span>
              <span class="menu_white"><i class="fa-solid fa-bell"></i></span>
            </b>
            <span>Notification</span>
          </a>
        </li>
        <li *ngIf="userType === 'apartment' && !isStaff || hasPermission('audit-logs')">
          <a
            [routerLink]="['/audit-logs']"
            [queryParams]="{ type: 'apartment' }"
            [ngClass]="{ active: router.url.startsWith('/audit-logs') }"
          >
            <b>
              <span class="menu_black"><i class="fa fa-history"></i></span>
              <span class="menu_white"><i class="fa fa-history"></i></span>
            </b>
            <span>Audit Logs</span>
          </a>
        </li>
      </ul>
    </li>
    <li *ngIf="userType === 'apartment' && !isStaff || hasPermission('ratings')">
      <a
        [routerLink]="['/ratings']"
        class="menu-item"
        [ngClass]="{ active: router.url === '/ratings' || (router.url.includes('/no-access') && router.url.includes('Ratings')) }"
        ><b>
          <span class="menu_black"><i class="fa-solid fa-star"></i></span>
          <span class="menu_white"><i class="fa-solid fa-star"></i></span></b
        ><span>Ratings</span>
      </a>
    </li>
    <li
      *ngIf="
        hasPermission('room-cash-settlement') ||
        (userType === 'apartment' && !isStaff && apartmentType !== 'residential')
      "
    >
      <a
        [routerLink]="['/room-cash-settlement']"
        [ngClass]="{ active: router.url == '/room-cash-settlement' || (router.url.includes('/no-access') && router.url.includes('Cash')) }"
        class="menu-item"
        ><b>
          <span class="menu_black"><i class="fa-solid fa-money-bill"></i></span>
          <span class="menu_white"
            ><i class="fa-solid fa-money-bill"></i
          ></span> </b
        ><span>Cash Settlement</span>
      </a>
    </li>
    <!-- <li *ngIf="userType === 'apartment' && !isStaff">
      <a [routerLink]="['/apartment-coupon']" [ngClass]="{ active: router.url.startsWith('/apartment-coupon') }"
        class="menu-item"><b>
          <span class="menu_black"><i class="fa-solid fa-ticket"></i></span>
          <span class="menu_white"><i class="fa-solid fa-ticket"></i></span> </b><span>Coupon</span>
      </a>
    </li> -->
    <li
      *ngIf="(userType === 'apartment' && !isStaff && apartmentType === 'residential') || hasPermission('room-community-notice') || hasPermission('gate-visitor') || hasPermission('gate-delivery') || hasPermission('gate-household-worker') || hasPermission('gate-staff-logs') || hasPermission('staff-attendance')"
      class="notification-dropdown"
    >
      <a
        href="javascript:void(0)"
        (click)="toggleDropdown('showLogsDropdown', $event)"
        class="menu-item"
        [ngClass]="{ active: router.url === '/room-community-notice' || router.url === '/digital-logs' || router.url === '/gate-visitor' || router.url === '/gate-delivery' || router.url === '/gate-household-worker' || router.url === '/gate-staff-logs' || router.url === '/gate-staff-attendance' }"
      >
        <b>
          <span class="menu_black"><i class="fa-solid fa-layer-group"></i></span>
          <span class="menu_white"><i class="fa-solid fa-layer-group"></i></span>
        </b>
        <span class="notify-text">
          Community & Gate
          <i
            class="fa-solid fa-chevron-down notify-arrow"
            [class.rotate]="showLogsDropdown"
          ></i>
        </span>
      </a>
      <ul class="notify-menu" *ngIf="showLogsDropdown">
        <li *ngIf="userType === 'apartment' && !isStaff || hasPermission('room-community-notice')">
          <a
            [routerLink]="['/room-community-notice']"
            [ngClass]="{ active: router.url === '/room-community-notice' }"
          >
            <b>
              <span class="menu_black"><i class="fa-solid fa-bullhorn"></i></span>
              <span class="menu_white"><i class="fa-solid fa-bullhorn"></i></span>
            </b>
            <span>Community Notice</span>
          </a>
        </li>
        <li *ngIf="userType === 'apartment' && !isStaff || hasPermission('gate-visitor')">
          <a
            [routerLink]="['/digital-logs']"
            [ngClass]="{ active: router.url === '/digital-logs' }"
          >
            <b>
              <span class="menu_black"><i class="fa-solid fa-clipboard-list"></i></span>
              <span class="menu_white"><i class="fa-solid fa-clipboard-list"></i></span>
            </b>
            <span>Digital Logs</span>
          </a>
        </li>
        <li *ngIf="userType === 'apartment' && !isStaff || hasPermission('gate-visitor')">
          <a
            [routerLink]="['/gate-visitor']"
            [ngClass]="{ active: router.url === '/gate-visitor' }"
          >
            <b>
              <span class="menu_black"><i class="fa fa-id-card"></i></span>
              <span class="menu_white"><i class="fa fa-id-card"></i></span>
            </b>
            <span>Visitor Logs</span>
          </a>
        </li>
        <li *ngIf="userType === 'apartment' && !isStaff || hasPermission('gate-delivery')">
          <a
            [routerLink]="['/gate-delivery']"
            [ngClass]="{ active: router.url === '/gate-delivery' }"
          >
            <b>
              <span class="menu_black"><i class="fa-solid fa-box"></i></span>
              <span class="menu_white"><i class="fa-solid fa-box"></i></span>
            </b>
            <span>Delivery Logs</span>
          </a>
        </li>
        <li *ngIf="userType === 'apartment' && !isStaff || hasPermission('gate-household-worker')">
          <a
            [routerLink]="['/gate-household-worker']"
            [ngClass]="{ active: router.url === '/gate-household-worker' }"
          >
            <b>
              <span class="menu_black"><i class="fa-solid fa-user"></i></span>
              <span class="menu_white"><i class="fa-solid fa-user"></i></span>
            </b>
            <span>Household Logs</span>
          </a>
        </li>
        <li *ngIf="userType === 'apartment' && !isStaff || hasPermission('gate-staff-logs')">
          <a
            [routerLink]="['/gate-staff-logs']"
            [ngClass]="{ active: router.url === '/gate-staff-logs' }"
          >
            <b>
              <span class="menu_black"><i class="fa-solid fa-user-shield"></i></span>
              <span class="menu_white"><i class="fa-solid fa-user-shield"></i></span>
            </b>
            <span>Gate Staff Logs</span>
          </a>
        </li>
        <li *ngIf="userType === 'apartment' && !isStaff || hasPermission('staff-attendance')">
          <a
            [routerLink]="['/gate-staff-attendance']"
            [ngClass]="{ active: router.url === '/gate-staff-attendance' }"
          >
            <b>
              <span class="menu_black"><i class="fa-solid fa-user-clock"></i></span>
              <span class="menu_white"><i class="fa-solid fa-user-clock"></i></span>
            </b>
            <span>Staff Management</span>
          </a>
        </li>
      </ul>
    </li>
    <li
      *ngIf="hasPermission('emergency') || (userType === 'apartment' && !isStaff)"
      class="notification-dropdown"
    >
      <a
        href="javascript:void(0)"
        (click)="toggleDropdown('showEmergencyDropdown', $event)"
        class="menu-item"
        [ngClass]="{ active: emergencyUrl() }"
      >
        <b>
          <span class="menu_black"
            ><i class="fa-solid fa-triangle-exclamation"></i
          ></span>
          <span class="menu_white"
            ><i class="fa-solid fa-triangle-exclamation"></i
          ></span>
        </b>
        <span class="notify-text">
          Emergency
          <i
            class="fa-solid fa-chevron-down notify-arrow"
            [class.rotate]="showEmergencyDropdown"
          ></i>
        </span>
      </a>
      <ul class="notify-menu" *ngIf="showEmergencyDropdown">
        <li>
          <a
            [routerLink]="['/emergency-notification']"
            [ngClass]="{ active: router.url === '/emergency-notification' }"
          >
            <b>
              <span class="menu_black"
                ><i class="fa-regular fa-file-lines"></i
              ></span>
              <span class="menu_white"
                ><i class="fa-regular fa-file-lines"></i
              ></span>
            </b>
            <span>Alert Template</span>
          </a>
        </li>
        <li>
          <a
            [routerLink]="['/floor-mapping']"
            [ngClass]="{ active: router.url === '/floor-mapping' }"
          >
            <b>
              <span class="menu_black"
                ><i class="fa-solid fa-layer-group"></i
              ></span>
              <span class="menu_white"
                ><i class="fa-solid fa-layer-group"></i
              ></span>
            </b>
            <span>Floor Mapping</span>
          </a>
        </li>
        <li>
          <a
            [routerLink]="['/active-alert']"
            [ngClass]="{ active: router.url === '/active-alert' }"
          >
            <b>
              <span class="menu_black"><i class="fa-solid fa-bell"></i></span>
              <span class="menu_white"><i class="fa-solid fa-bell"></i></span>
            </b>
            <span>Active Alert</span>
          </a>
        </li>
        <li>
          <a
            [routerLink]="['/alert-history']"
            [ngClass]="{
              active:
                router.url === '/alert-history' ||
                router.url.startsWith('/alert-response'),
            }"
          >
            <b>
              <span class="menu_black"><i class="fa fa-history"></i></span>
              <span class="menu_white"><i class="fa fa-history"></i></span>
            </b>
            <span>Alert History</span>
          </a>
        </li>
      </ul>
    </li>
    <li *ngIf="hasPermission('sos-history') || (userType === 'apartment' && !isStaff)">
      <a
        [routerLink]="['/sos-history']"
        class="menu-item"
        [ngClass]="{ active: router.url == '/sos-history' }"
        ><b>
          <span class="menu_black"><i class="fa-solid fa-truck-medical"></i></span>
          <span class="menu_white"><i class="fa-solid fa-truck-medical"></i></span
        ></b>
        <span>SOS History</span>
      </a>
    </li>

    <li *ngIf="hasPermission('dashboard-laundry') || userType === 'laundry'">
      <a
        [routerLink]="['/dashboard-laundry']"
        class="menu-item"
        [ngClass]="{ active: router.url == '/dashboard-laundry' }"
        ><b>
          <span class="menu_black"><i class="fa-solid fa-gauge"></i></span>
          <span class="menu_white"><i class="fa-solid fa-gauge"></i></span
        ></b>
        <span>Dashboard</span>
      </a>
    </li>
    <li *ngIf="hasPermission('laundry') || userType === 'laundry'">
      <a
        [routerLink]="['/laundry']"
        class="menu-item"
        [ngClass]="{ active: LaundryUrl() }"
        ><b>
          <span class="menu_black"><i class="fa-solid fa-shirt"></i></span>
          <span class="menu_white"><i class="fa-solid fa-shirt"></i></span></b
        ><span>Laundry</span>
      </a>
    </li>
    <li
      *ngIf="hasPermission('upload-laundry-banner') || userType === 'laundry'"
    >
      <a
        [routerLink]="['/upload-laundry-banner']"
        [ngClass]="{ active: router.url == '/upload-laundry-banner' }"
        ><b>
          <img
            src="assets/images/advertise1.svg"
            class="menu_black"
            style="width: 100%" />
          <img
            src="assets/images/advertise2.svg"
            class="menu_white"
            style="width: 100%"
        /></b>
        <span>Banner Image</span>
      </a>
    </li>

    <li *ngIf="userType === 'laundry' && (hasPermission('new-order') || !isStaff)">
      <a
        [ngClass]="{ active: deliveryActiveurl() }"
        class="menu-item"
        [routerLink]="['/new-order']"
        ><b>
          <span class="menu_black"
            ><i class="fa-solid fa-cart-shopping"></i
          ></span>
          <span class="menu_white"
            ><i class="fa-solid fa-cart-shopping"></i
          ></span>
        </b>
        <span>Order</span>
      </a>
      <span class="notif_msg" *ngIf="getNewOrdersCount?.['0'] >= 1">
        {{ getNewOrdersCount?.["0"] }}
      </span>
    </li>
    <li *ngIf="hasPermission('laundry-staff') || userType === 'laundry'">
      <a
        [routerLink]="['/laundry-staff']"
        class="menu-item"
        [ngClass]="{ active: StaffUrl() }"
        ><b>
          <span class="menu_black"><i class="fa-solid fa-id-badge"></i></span>
          <span class="menu_white"
            ><i class="fa-solid fa-id-badge"></i></span></b
        ><span>Staff</span>
      </a>
    </li>
    <li *ngIf="hasPermission('reports-laundry') || userType === 'laundry'">
      <a [routerLink]="['/reports-laundry']" [ngClass]="{ active: router.url == '/reports-laundry' }" class="menu-item">
        <b>
          <span class="menu_black"><i class="fa fa-file-text" aria-hidden="true"></i></span>
          <span class="menu_white"><i class="fa fa-file-text" aria-hidden="true"></i></span>
        </b>
        <span>Report</span>
      </a>
    </li>
    <li *ngIf="userType === 'laundry'">
      <a [routerLink]="['/laundry-coupon']" [ngClass]="{ active: router.url.startsWith('/laundry-coupon') }" class="menu-item">
        <b>
          <span class="menu_black"><i class="fa fa-tag" aria-hidden="true"></i></span>
          <span class="menu_white"><i class="fa fa-tag" aria-hidden="true"></i></span>
        </b>
        <span>Coupon</span>
      </a>
    </li>
    <li *ngIf="userType === 'laundry'">
      <a [routerLink]="['/ratings']" [ngClass]="{ active: router.url === '/ratings' }" class="menu-item">
        <b>
          <span class="menu_black"><i class="fa fa-star" aria-hidden="true"></i></span>
          <span class="menu_white"><i class="fa fa-star" aria-hidden="true"></i></span>
        </b>
        <span>Ratings</span>
      </a>
    </li>
    <li
      *ngIf="userType === 'laundry'"
      class="notification-dropdown"
    >
      <a
        href="javascript:void(0)"
        (click)="toggleDropdown('showLaundryFinanceDropdown', $event)"
        class="menu-item"
        [ngClass]="{ active: router.url == '/laundry-settlement' || router.url == '/cash-settlement' }"
      >
        <b>
          <span class="menu_black"><i class="fa fa-credit-card"></i></span>
          <span class="menu_white"><i class="fa fa-credit-card"></i></span>
        </b>
        <span class="notify-text">
          Settlement
          <i class="fa fa-chevron-down notify-arrow" [class.rotate]="showLaundryFinanceDropdown"></i>
        </span>
      </a>
      <ul class="notify-menu" *ngIf="showLaundryFinanceDropdown">
        <li>
          <a [routerLink]="['/laundry-settlement']" [ngClass]="{ active: router.url == '/laundry-settlement' }">
            <b>
              <span class="menu_black"><i class="fa fa-file-text"></i></span>
              <span class="menu_white"><i class="fa fa-file-text"></i></span>
            </b>
            <span>Vendor Settlement</span>
          </a>
        </li>
        <li *ngIf="hasPermission('cash-settlement') || userType === 'laundry'">
          <a [routerLink]="['/cash-settlement']" [ngClass]="{ active: router.url == '/cash-settlement' }">
            <b>
              <span class="menu_black"><i class="fa fa-tag"></i></span>
              <span class="menu_white"><i class="fa fa-tag"></i></span>
            </b>
            <span>Cash Settlement</span>
          </a>
        </li>
      </ul>
    </li>
    <li *ngIf="userType === 'laundry'">
      <a [routerLink]="['/laundry-outlet-timings']" [ngClass]="{ active: router.url == '/laundry-outlet-timings' }" class="menu-item">
        <b>
          <span class="menu_black"><i class="fa fa-calendar"></i></span>
          <span class="menu_white"><i class="fa fa-calendar"></i></span>
        </b>
        <span>Outlet Timings</span>
      </a>
    </li>
    <!-- <li *ngIf="userType === 'restaurant' || userType === 'apartment' && !isStaff">
      <a [routerLink]="['/restaurants']" [ngClass]="{ active: RestaurantUrl() }"><b>
          <img src="assets/images/advertise1.svg" class="menu_black" style="width: 100%;" />
          <img src="assets/images/advertise2.svg" class="menu_white" style="width: 100%;" /></b>
        <span>Restaurant</span>
      </a>
    </li> -->
    <li
      *ngIf="hasPermission('restaurant-dashboard') || userType === 'restaurant'"
    >
      <a
        [routerLink]="['/restaurant-dashboard']"
        class="menu-item"
        [ngClass]="{ active: router.url == '/restaurant-dashboard' }"
        ><b>
          <span class="menu_black"><i class="fa-solid fa-gauge"></i></span>
          <span class="menu_white"><i class="fa-solid fa-gauge"></i></span
        ></b>
        <span>Dashboard</span>
      </a>
    </li>
    <li
      *ngIf="
        hasPermission('menu-management/food-item') || userType === 'restaurant'
      "
    >
      <a
        [routerLink]="['/menu-management/food-item']"
        [ngClass]="{ active: MenumanagementUrl() }"
        ><b>
          <img
            src="assets/images/restuarant.svg"
            class="menu_black"
            style="width: 100%" />
          <img
            src="assets/images/restuarant.svg"
            class="menu_white"
            style="width: 100%"
        /></b>
        <span>Menu Management</span>
      </a>
    </li>
    <li
      *ngIf="
        hasPermission('upload-restaurant-banner') || userType === 'restaurant'
      "
    >
      <a
        [routerLink]="['/upload-restaurant-banner']"
        [ngClass]="{ active: router.url == '/upload-restaurant-banner' }"
        ><b>
          <img
            src="assets/images/advertise1.svg"
            class="menu_black"
            style="width: 100%" />
          <img
            src="assets/images/advertise2.svg"
            class="menu_white"
            style="width: 100%"
        /></b>
        <span>Banner Image</span>
      </a>
    </li>
    <li *ngIf="hasPermission('food-new-order') || userType === 'restaurant'">
      <a
        [ngClass]="{ active: router.url == '/food-new-order' }"
        class="menu-item"
        [routerLink]="['/food-new-order']"
        ><b>
          <span class="menu_black"><i class="fa-solid fa-utensils"></i></span>
          <span class="menu_white"><i class="fa-solid fa-utensils"></i></span>
        </b>
        <span>Order List</span>
      </a>
      <span class="notif_msg" *ngIf="getNewFoodOrdersCount?.['0'] >= 1">
        {{ getNewFoodOrdersCount?.["0"] }}
      </span>
    </li>
    <li *ngIf="hasPermission('food-new-order') || userType === 'restaurant'">
      <a
        [ngClass]="{ active: router.url == '/food-order-kanban' }"
        class="menu-item"
        [routerLink]="['/food-order-kanban']"
        ><b>
          <span class="menu_black"><i class="fa-solid fa-table-columns"></i></span>
          <span class="menu_white"><i class="fa-solid fa-table-columns"></i></span>
        </b>
        <span>Order Kanban View</span>
      </a>
    </li>
    <li *ngIf="hasPermission('restaurant-staff') || userType === 'restaurant'">
      <a
        [routerLink]="['/restaurant-staff']"
        class="menu-item"
        [ngClass]="{ active: restaurantStaffUrl() }"
        ><b>
          <span class="menu_black"><i class="fa-solid fa-id-badge"></i></span>
          <span class="menu_white"><i class="fa-solid fa-id-badge"></i></span
        ></b>
        <span>Staff</span>
      </a>
    </li>
    <li *ngIf="hasPermission('reports-restaurant') || userType === 'restaurant'">
      <a [routerLink]="['/reports-restaurant']" [ngClass]="{ active: router.url == '/reports-restaurant' }" class="menu-item">
        <b>
          <span class="menu_black"><i class="fa fa-file-text" aria-hidden="true"></i></span>
          <span class="menu_white"><i class="fa fa-file-text" aria-hidden="true"></i></span>
        </b>
        <span>Report</span>
      </a>
    </li>
    <li *ngIf="userType === 'restaurant'">
      <a [routerLink]="['/restaurant-coupon']" [ngClass]="{ active: router.url.startsWith('/restaurant-coupon') }" class="menu-item">
        <b>
          <span class="menu_black"><i class="fa fa-tag" aria-hidden="true"></i></span>
          <span class="menu_white"><i class="fa fa-tag" aria-hidden="true"></i></span>
        </b>
        <span>Coupon</span>
      </a>
    </li>
    <li *ngIf="userType === 'restaurant'">
      <a [routerLink]="['/ratings']" [ngClass]="{ active: router.url === '/ratings' }" class="menu-item">
        <b>
          <span class="menu_black"><i class="fa fa-star" aria-hidden="true"></i></span>
          <span class="menu_white"><i class="fa fa-star" aria-hidden="true"></i></span>
        </b>
        <span>Ratings</span>
      </a>
    </li>
    <li
      *ngIf="userType === 'restaurant'"
      class="notification-dropdown"
    >
      <a
        href="javascript:void(0)"
        (click)="toggleDropdown('showRestaurantFinanceDropdown', $event)"
        class="menu-item"
        [ngClass]="{ active: router.url == '/restaurant-settlement' || router.url == '/food-cash-settlement' }"
      >
        <b>
          <span class="menu_black"><i class="fa fa-credit-card"></i></span>
          <span class="menu_white"><i class="fa fa-credit-card"></i></span>
        </b>
        <span class="notify-text">
          Settlement
          <i class="fa fa-chevron-down notify-arrow" [class.rotate]="showRestaurantFinanceDropdown"></i>
        </span>
      </a>
      <ul class="notify-menu" *ngIf="showRestaurantFinanceDropdown">
        <li>
          <a [routerLink]="['/restaurant-settlement']" [ngClass]="{ active: router.url == '/restaurant-settlement' }">
            <b>
              <span class="menu_black"><i class="fa fa-file-text"></i></span>
              <span class="menu_white"><i class="fa fa-file-text"></i></span>
            </b>
            <span>Vendor Settlement</span>
          </a>
        </li>
        <li *ngIf="hasPermission('food-cash-settlement') || userType === 'restaurant'">
          <a [routerLink]="['/food-cash-settlement']" [ngClass]="{ active: router.url == '/food-cash-settlement' }">
            <b>
              <span class="menu_black"><i class="fa fa-tag"></i></span>
              <span class="menu_white"><i class="fa fa-tag"></i></span>
            </b>
            <span>Cash Settlement</span>
          </a>
        </li>
      </ul>
    </li>
    <li *ngIf="userType === 'restaurant'">
      <a [routerLink]="['/food-outlet-timings']" [ngClass]="{ active: router.url == '/food-outlet-timings' }" class="menu-item">
        <b>
          <span class="menu_black"><i class="fa fa-calendar"></i></span>
          <span class="menu_white"><i class="fa fa-calendar"></i></span>
        </b>
        <span>Outlet Timings</span>
      </a>
    </li>
    <!-- <li *ngIf="hasPermission('restaurant-notification') || userType === 'restaurant'">
      <a [routerLink]="['/restaurant-notification']" [ngClass]="{ active: router.url == '/restaurant-notification' }"
        class="menu-item"><b>
          <span class="menu_black"><i class="fa-solid fa-bell"></i></span>
          <span class="menu_white"><i class="fa-solid fa-bell"></i></span></b><span>Notification</span>
      </a>
    </li> -->
    <!------------- club ---------------------->
    <li *ngIf="hasPermission('dashboard-club') || (userType === 'club' && !isStaff)">
      <a
        [routerLink]="['/club/dashboard']"
        [ngClass]="{ active: router.url == '/club/dashboard' }"
        class="menu-item"
        ><b>
          <span class="menu_black"><i class="fa-solid fa-gauge"></i></span>
          <span class="menu_white"><i class="fa-solid fa-gauge"></i></span></b
        ><span>Dashboard</span>
      </a>
    </li>
    <li *ngIf="hasPermission('club-banner') || (userType === 'club' && !isStaff)">
      <a
        [routerLink]="['/club/banner']"
        [ngClass]="{ active: router.url == '/club/banner' }"
        class="menu-item"
        ><b>
          <span class="menu_black"><i class="fa-solid fa-photo-film"></i></span>
          <span class="menu_white"
            ><i class="fa-solid fa-photo-film"></i></span></b
        ><span>Media-management</span>
      </a>
    </li>
    <li
      *ngIf="
        hasPermission('club-pricing') ||
        hasPermission('club-table-type') ||
        (userType === 'club' && !isStaff)
      "
      class="notification-dropdown"
    >
      <a
        href="javascript:void(0)"
        (click)="toggleDropdown('showClubPricingDropdown', $event)"
        class="menu-item"
        [ngClass]="{
          active:
            router.url == '/club/pricing' || router.url == '/club/table-type',
        }"
      >
        <b>
          <span class="menu_black"
            ><i class="fa-solid fa-money-bill-wave"></i
          ></span>
          <span class="menu_white"
            ><i class="fa-solid fa-money-bill-wave"></i
          ></span>
        </b>
        <span class="notify-text">
          Pricing
          <i
            class="fa fa-chevron-down notify-arrow"
            [class.rotate]="showClubPricingDropdown"
          ></i>
        </span>
      </a>
      <ul class="notify-menu" *ngIf="showClubPricingDropdown">
        <li
          *ngIf="
            hasPermission('club-pricing') || (userType === 'club' && !isStaff)
          "
        >
          <a
            [routerLink]="['/club/pricing']"
            [ngClass]="{ active: router.url == '/club/pricing' }"
          >
            <b>
              <span class="menu_black"
                ><i class="fa-solid fa-money-bill-wave"></i
              ></span>
              <span class="menu_white"
                ><i class="fa-solid fa-money-bill-wave"></i
              ></span>
            </b>
            <span>Entry Pricing</span>
          </a>
        </li>
        <li
          *ngIf="
            hasPermission('club-table-type') || (userType === 'club' && !isStaff)
          "
        >
          <a
            [routerLink]="['/club/table-type']"
            [ngClass]="{ active: router.url == '/club/table-type' }"
          >
            <b>
              <span class="menu_black"><i class="fa-solid fa-table"></i></span>
              <span class="menu_white"><i class="fa-solid fa-table"></i></span>
            </b>
            <span>Table / Drinks Pricing</span>
          </a>
        </li>
      </ul>
    </li>
    <li *ngIf="hasPermission('club-slot-generation') || (userType === 'club' && !isStaff)">
      <a
        [routerLink]="['/club/slot-generation']"
        [ngClass]="{ active: router.url == '/club/slot-generation' }"
        class="menu-item"
        ><b>
          <span class="menu_black"
            ><i class="fa-solid fa-calendar-plus"></i
          ></span>
          <span class="menu_white"
            ><i class="fa-solid fa-calendar-plus"></i></span></b
        ><span>Slot-generation</span>
      </a>
    </li>

    <li *ngIf="hasPermission('club-slot-management') || (userType === 'club' && !isStaff)">
      <a
        [routerLink]="['/club/slot-management']"
        [ngClass]="{ active: router.url == '/club/slot-management' }"
        class="menu-item"
        ><b>
          <span class="menu_black"><i class="fa-solid fa-sliders"></i></span>
          <span class="menu_white"><i class="fa-solid fa-sliders"></i></span></b
        ><span>Club-management</span>
      </a>
    </li>
    <!-- Booking-management and Bookings are two separate top-level items; they
         used to share one "Bookings" dropdown. -->
    <li
      *ngIf="
        hasPermission('club-booking-management') ||
        (userType === 'club' && !isStaff)
      "
    >
      <a
        [routerLink]="['/club/booking-management']"
        [ngClass]="{ active: router.url == '/club/booking-management' }"
        class="menu-item"
        ><b>
          <span class="menu_black"><i class="fa-solid fa-sliders"></i></span>
          <span class="menu_white"><i class="fa-solid fa-sliders"></i></span></b
        ><span>Booking-management</span>
      </a>
    </li>
    <li
      *ngIf="hasPermission('club-booking') || (userType === 'club' && !isStaff)"
    >
      <a
        [routerLink]="['/club/booking']"
        [ngClass]="{ active: router.url == '/club/booking' }"
        class="menu-item"
        ><b>
          <span class="menu_black"
            ><i class="fa-solid fa-calendar-check"></i
          ></span>
          <span class="menu_white"
            ><i class="fa-solid fa-calendar-check"></i
          ></span></b
        ><span>Bookings</span>
      </a>
      <span class="notif_msg" *ngIf="getNewBookingsCount?.['1'] >= 1">
        {{ getNewBookingsCount?.["1"] }}
      </span>
    </li>
    <li *ngIf="hasPermission('club-settlement') || (userType === 'club' && !isStaff)">
      <a
        [routerLink]="['/club-settlement']"
        [ngClass]="{ active: router.url == '/club-settlement' }"
        class="menu-item"
        ><b>
          <span class="menu_black"><i class="fa fa-credit-card"></i></span>
          <span class="menu_white"><i class="fa fa-credit-card"></i></span></b
        ><span>Vendor Settlement</span>
      </a>
    </li>
    <li *ngIf="hasPermission('club-staff') || (userType === 'club' && !isStaff)">
      <a
        [routerLink]="['/club/staff']"
        [ngClass]="{ active: router.url.startsWith('/club/staff') }"
        class="menu-item"
        ><b>
          <span class="menu_black"><i class="fa-solid fa-user-tie"></i></span>
          <span class="menu_white"><i class="fa-solid fa-user-tie"></i></span></b
        ><span>Staff</span>
      </a>
    </li>
    <li *ngIf="hasPermission('club-coupon') || (userType === 'club' && !isStaff)">
      <a
        [routerLink]="['/club-coupon']"
        [ngClass]="{ active: router.url.startsWith('/club-coupon') }"
        class="menu-item"
        ><b>
          <span class="menu_black"><i class="fa fa-tag" aria-hidden="true"></i></span>
          <span class="menu_white"><i class="fa fa-tag" aria-hidden="true"></i></span></b
        ><span>Coupon</span>
      </a>
    </li>
    <li *ngIf="hasPermission('club-special-offers') || (userType === 'club' && !isStaff)">
      <a
        [routerLink]="['/club-special-offers']"
        [ngClass]="{ active: router.url.startsWith('/club-special-offers') }"
        class="menu-item"
        ><b>
          <span class="menu_black"><i class="fa fa-gift" aria-hidden="true"></i></span>
          <span class="menu_white"><i class="fa fa-gift" aria-hidden="true"></i></span></b
        ><span>Special Offers</span>
      </a>
    </li>
    <li *ngIf="userType === 'club' && !isStaff">
      <a
        [routerLink]="['/club/report']"
        [ngClass]="{ active: router.url.startsWith('/club/report') }"
        class="menu-item"
        ><b>
          <span class="menu_black"><i class="fa fa-file-text" aria-hidden="true"></i></span>
          <span class="menu_white"><i class="fa fa-file-text" aria-hidden="true"></i></span></b
        ><span>Report</span>
      </a>
    </li>
    <li *ngIf="userType === 'club' && !isStaff">
      <a
        [routerLink]="['/club/ratings']"
        [ngClass]="{ active: router.url.startsWith('/club/ratings') }"
        class="menu-item"
        ><b>
          <span class="menu_black"><i class="fa fa-star" aria-hidden="true"></i></span>
          <span class="menu_white"><i class="fa fa-star" aria-hidden="true"></i></span></b
        ><span>Ratings</span>
      </a>
    </li>
    <!------------- spa ---------------------->
    <li *ngIf="userType === 'spa'">
      <a
        [routerLink]="['/spa/slot-generation']"
        [ngClass]="{ active: router.url == '/spa/slot-generation' }"
        class="menu-item"
        ><b>
          <span class="menu_black"><i class="fa-solid fa-calendar-plus"></i></span>
          <span class="menu_white"><i class="fa-solid fa-calendar-plus"></i></span></b
        ><span>Slot Generation</span>
      </a>
    </li>
    <li *ngIf="userType === 'spa'">
      <a
        [routerLink]="['/spa/category']"
        [ngClass]="{ active: router.url == '/spa/category' }"
        class="menu-item"
        ><b>
          <span class="menu_black"><i class="fa-solid fa-tags"></i></span>
          <span class="menu_white"><i class="fa-solid fa-tags"></i></span></b
        ><span>Category</span>
      </a>
    </li>
  </ul>
</div>

<!-- NOTIFICATION BELL -->
<div class="notif-container">
  <!-- Bell Button -->
  <button
    class="notif-bell-btn"
    type="button"
    title="Notifications"
    aria-label="Notifications"
    (click)="toggleNotifPanel()"
  >
    <i class="fa-regular fa-bell"></i>
    <span class="notif-badge" *ngIf="notifications.length > 0">
      {{ totalCount }}
    </span>
  </button>

  <!-- Panel -->
  <div class="notif-panel" *ngIf="showNotifPanel">
    <!-- Header -->
    <div class="notif-panel-header">
      <div class="notif-panel-title-row">
        <span class="notif-panel-title">
          <i class="fa-regular fa-bell"></i> Notifications
        </span>
        <button
          class="notif-close-btn"
          type="button"
          title="Close"
          (click)="showNotifPanel = false"
        >
          <i class="fa-solid fa-xmark"></i>
        </button>
      </div>

      <!-- Subscribe Toggle -->
      <button
        class="notif-subscribe-btn"
        [class.subscribed]="isSubscribed"
        [class.unsubscribed]="!isSubscribed"
        (click)="toggleSubscription()"
      >
        {{
          isSubscribed
            ? "Unsubscribe from notifications"
            : "Subscribe to notifications"
        }}
      </button>
    </div>

    <!-- Actions Row -->
    <div class="notif-actions" *ngIf="notifications.length > 0">
      <button class="notif-clear-btn" (click)="clearNotifications()">
        Clear all
      </button>
    </div>

    <!-- List -->
    <div class="notif-list" (scroll)="onNotifScroll($event)">
      <!-- Empty -->
      <div class="notif-empty" *ngIf="notifications.length === 0">
        <div class="notif-empty-icon"><i class="fa-regular fa-bell-slash"></i></div>
        <div class="notif-empty-title">No notifications yet</div>
        <div class="notif-empty-subtitle">Subscribe to receive alerts</div>
      </div>

      <!-- Items -->
      <div class="notif-loading" *ngIf="notifLoading">
        <span>Loading…</span>
      </div>

      <div
        class="notif-empty"
        *ngIf="!notifLoading && notifications.length === 0"
      ></div>

      <div *ngFor="let n of notifications" class="notif-item">
        <div class="notif-item-inner">
          <!-- Icon -->
          <div
            class="notif-icon"
            [class.notif-icon-cancel]="
              n.heading.includes('Cancel') || n.heading.includes('Reject')
            "
            [class.notif-icon-delivered]="n.heading.includes('Deliver')"
            [class.notif-icon-order]="
              !n.heading.includes('Cancel') &&
              !n.heading.includes('Reject') &&
              !n.heading.includes('Deliver')
            "
          >
            {{
              n.heading.includes("Cancel") || n.heading.includes("Reject")
                ? "❌"
                : n.heading.includes("Deliver")
                  ? "✅"
                  : "🛎️"
            }}
          </div>

          <!-- Content -->
          <div class="notif-content">
            <div class="notif-content-top">
              <span class="notif-title">{{ n.heading }}</span>
              <span class="notif-time">{{ getTimeAgo(n.createdAt) }}</span>
            </div>
            <p class="notif-body">{{ n.description }}</p>
            <p class="notif-invoice" *ngIf="n.invoiceNumber">
              #{{ n.invoiceNumber }}
            </p>
          </div>

          <!-- Per-item delete button -->
          <button
            class="notif-item-delete-btn"
            title="Dismiss"
            (click)="$event.stopPropagation(); deleteOneNotification(n._id)"
          >
            <i class="fa-solid fa-xmark"></i>
          </button>

          <!-- Unread dot -->
        </div>
      </div>
      <div class="notif-scroll-status" *ngIf="notifications.length > 0">
        <span *ngIf="notifLoading">Loading…</span>
        <span *ngIf="!notifLoading && !notifHasNext">You're all caught up</span>
      </div>
    </div>

    <!-- Footer -->
    <div class="notif-footer" *ngIf="notifications.length > 0">
      {{ notifications.length }} total notifications
    </div>
  </div>
</div>

<!-- Backdrop -->
<div
  class="notif-backdrop"
  *ngIf="showNotifPanel"
  (click)="showNotifPanel = false"
></div>

<!-- Resident SOS: full-screen siren, minimised into the header dock (sosDock) -->
<div class="sos_overlay" *ngIf="canSeeSos && (sosAlert.expanded$ | async)" [class.sos_flying]="sosFlying">
  <div class="sos_overlay_card">
    <div class="sos_stage">
      <span class="sos_beams"></span>
      <span class="sos_ring"></span>
      <span class="sos_ring sos_ring_2"></span>
      <span class="sos_ring sos_ring_3"></span>
      <div class="sos_siren sos_siren_lg" #sosSiren>
        <ng-container *ngTemplateOutlet="sirenTpl; context: { $implicit: 'lg' }"></ng-container>
      </div>
    </div>

    <div class="sos_overlay_text">
      <span class="sos_chip"><span class="sos_live_dot"></span>Emergency · Live</span>
      <h3>SOS Alert</h3>
      <p>A resident has raised an emergency SOS and needs immediate assistance.</p>
      <div class="sos_meta" *ngIf="sosAlert.lastArrivedAt">
        <i class="fa-regular fa-clock"></i> Received at {{ sosAlert.lastArrivedAt | date: 'h:mm a' }}
        <ng-container *ngIf="sosAlert.activeCount > 1"> · {{ sosAlert.activeCount }} active alerts</ng-container>
      </div>
      <div class="sos_overlay_actions">
        <button type="button" class="sos_btn_ghost" (click)="minimiseSos()">
          <i class="fa-solid fa-down-left-and-up-right-to-center"></i> Minimise
        </button>
        <button type="button" class="sos_btn_primary" (click)="openSosHistory()">
          View SOS <i class="fa-solid fa-arrow-right"></i>
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Siren artwork, shared by the full-screen alert ('lg') and the header dock ('sm');
     the key keeps each copy's gradient ids unique -->
<ng-template #sirenTpl let-k>
  <svg class="sos_svg" viewBox="0 0 120 132" aria-hidden="true">
    <defs>
      <radialGradient [attr.id]="'sosGlass' + k" cx="50%" cy="80%" r="78%">
        <stop offset="0" stop-color="#ffd2c9" />
        <stop offset="0.2" stop-color="#ff5a5f" />
        <stop offset="0.58" stop-color="#d9111c" />
        <stop offset="1" stop-color="#5e040a" />
      </radialGradient>
      <radialGradient [attr.id]="'sosBulb' + k" cx="50%" cy="50%" r="50%">
        <stop offset="0" stop-color="#ffffff" />
        <stop offset="0.35" stop-color="#ffe3c4" stop-opacity="0.95" />
        <stop offset="1" stop-color="#ff7a5a" stop-opacity="0" />
      </radialGradient>
      <linearGradient [attr.id]="'sosBeam' + k" x1="0" y1="0" x2="1" y2="0">
        <stop offset="0" stop-color="#fff2e6" stop-opacity="0" />
        <stop offset="0.5" stop-color="#fff2e6" stop-opacity="0.9" />
        <stop offset="1" stop-color="#fff2e6" stop-opacity="0" />
      </linearGradient>
      <linearGradient [attr.id]="'sosShine' + k" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stop-color="#ffffff" stop-opacity="0.85" />
        <stop offset="1" stop-color="#ffffff" stop-opacity="0" />
      </linearGradient>
      <linearGradient [attr.id]="'sosChrome' + k" x1="0" y1="0" x2="1" y2="0">
        <stop offset="0" stop-color="#7d828a" />
        <stop offset="0.35" stop-color="#f4f6f8" />
        <stop offset="0.55" stop-color="#b9bec5" />
        <stop offset="1" stop-color="#4f545c" />
      </linearGradient>
      <linearGradient [attr.id]="'sosMetal' + k" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stop-color="#6b7079" />
        <stop offset="0.35" stop-color="#3a3e45" />
        <stop offset="0.75" stop-color="#1d1f23" />
        <stop offset="1" stop-color="#0e0f11" />
      </linearGradient>
      <clipPath [attr.id]="'sosDomeClip' + k">
        <path d="M24 92 L26 50 C27 26 42 14 60 14 C78 14 93 26 94 50 L96 92 Z" />
      </clipPath>
    </defs>

    <!-- Cap -->
    <rect x="51" y="7" width="18" height="9" rx="3" [attr.fill]="'url(#sosChrome' + k + ')'" />

    <!-- Glass dome -->
    <path d="M24 92 L26 50 C27 26 42 14 60 14 C78 14 93 26 94 50 L96 92 Z" [attr.fill]="'url(#sosGlass' + k + ')'" />
    <g [attr.clip-path]="'url(#sosDomeClip' + k + ')'">
      <ellipse class="sos_svg_bulb" cx="60" cy="72" rx="24" ry="26" [attr.fill]="'url(#sosBulb' + k + ')'" />
      <rect class="sos_svg_beam" x="-34" y="10" width="34" height="86" [attr.fill]="'url(#sosBeam' + k + ')'" />
      <rect class="sos_svg_beam sos_svg_beam_2" x="-34" y="10" width="34" height="86" [attr.fill]="'url(#sosBeam' + k + ')'" />
      <!-- Fresnel ribs -->
      <g fill="none" stroke="#ffffff" stroke-opacity="0.18" stroke-width="1">
        <path d="M37 92 C35 62 39 36 48 20" />
        <path d="M49 92 C48 62 50 36 55 16" />
        <path d="M71 92 C72 62 70 36 65 16" />
        <path d="M83 92 C85 62 81 36 72 20" />
        <path d="M25 58 C45 63 75 63 95 58" />
        <path d="M25 76 C45 81 75 81 95 76" />
      </g>
    </g>
    <!-- Glass shine and rim light -->
    <path d="M33 84 C30 58 35 36 50 23 C42 40 40 60 42 84 Z" [attr.fill]="'url(#sosShine' + k + ')'" opacity="0.7" />
    <path d="M89 46 C91 60 92 74 92 86" fill="none" stroke="#ffffff" stroke-opacity="0.4" stroke-width="2" stroke-linecap="round" />
    <path d="M24 92 L26 50 C27 26 42 14 60 14 C78 14 93 26 94 50 L96 92 Z" fill="none" stroke="#4a0207" stroke-opacity="0.6" />

    <!-- Chrome collar -->
    <rect x="18" y="89" width="84" height="9" rx="3" [attr.fill]="'url(#sosChrome' + k + ')'" />

    <!-- Gunmetal base with LED strip and bolts -->
    <path d="M12 98 H108 L114 121 C114 124.5 112 127 108.5 127 H11.5 C8 127 6 124.5 6 121 Z" [attr.fill]="'url(#sosMetal' + k + ')'" />
    <path d="M14 100.5 H106" stroke="#ffffff" stroke-opacity="0.28" />
    <rect class="sos_svg_led" x="32" y="110" width="56" height="4" rx="2" fill="#ff3b45" />
    <circle cx="19" cy="112" r="2.6" [attr.fill]="'url(#sosChrome' + k + ')'" />
    <circle cx="101" cy="112" r="2.6" [attr.fill]="'url(#sosChrome' + k + ')'" />
  </svg>
</ng-template>
